module.exports = __webpack_public_path__ + "static/img/setting_active.c253d9ca.svg";